<span :class="`icon--wrapper ${wrapperClass}`" @click="handleIconClick" v-bind="attributes">
	<span :class="'icon ' + this.iconProcessed"></span>
</span>
